import { create } from "zustand";
import { whereFilterType } from "src/types/types";

export enum DrawerComponent {
  FILTERS = "filters",
  SEARCH = "search",
  OTHER = "other",
}

type Methods = {
  setIsIndexed: (notIndexed: boolean) => void;
  setActiveDrawerComponents: (components: DrawerComponent[]) => void;
  setShowSideDrawer: (show: boolean) => void;
  toggleDrawer: (component: DrawerComponent) => void;
  setActiveDrawerComponentsAndShow: (components: DrawerComponent[]) => void;
  setWhereFilters: (filters: whereFilterType[]) => void;
  hasActiveFilters: () => boolean;
};

type Props = {
  isIndexed: boolean;
  activeDrawerComponents: DrawerComponent[];
  showSideDrawer: boolean;
  whereFilters: whereFilterType[];
};

type DatasetViewerStore = Props & Methods;

export const useDatasetViewerStore = create<DatasetViewerStore>()(
  (set, get) => ({
    // PROPS
    isIndexed: false,
    activeDrawerComponents: [],
    showSideDrawer: false,
    whereFilters: [],

    // METHODS
    setIsIndexed: (notIndexed) => {
      set({ isIndexed: notIndexed });
    },
    setActiveDrawerComponents: (components) => {
      set({ activeDrawerComponents: components });
    },
    setShowSideDrawer: (show) => {
      set({ showSideDrawer: show });
    },
    toggleDrawer: (component) => {
      set((state) => {
        const currentComponents = [...state.activeDrawerComponents];
        const componentIndex = currentComponents.indexOf(component);

        if (componentIndex > -1) {
          currentComponents.splice(componentIndex, 1);
        } else {
          currentComponents.push(component);
        }

        return {
          activeDrawerComponents: currentComponents,
          showSideDrawer: currentComponents.length > 0,
        };
      });
    },
    setActiveDrawerComponentsAndShow: (components) => {
      set({
        activeDrawerComponents: components,
        showSideDrawer: components.length > 0,
      });
    },
    setWhereFilters: (filters) => {
      set({ whereFilters: filters });
    },
    hasActiveFilters: () => {
      return get().whereFilters.length > 0;
    },
  }),
);
